/* Dreavaya catalog layer (WS1): DV.cat, DV.pocket, DV.rail, quick add, load more, shared card video. Runs after dv-cart.js. */
(function () {
  const CFG = window.DV_CFG || {}, DV = (window.DV = window.DV || {}), root = CFG.root || '/', D = document;
  const on = (t, f, o) => D.addEventListener(t, f, o), box = (el) => el.getBoundingClientRect();
  let C = {}; try { C = JSON.parse(D.getElementById('DvCartData').textContent); } catch (e) {}
  const tierOff = C.tierOff || [0, 0, 0, 0, 0], bookType = CFG.bookType || 'Refillable Shaker Binder';
  const dec = (o) => { const d = D.createElement('textarea'); Object.keys(o).forEach((k) => { d.innerHTML = o[k]; o[k] = d.value; }); return o; };  // locale strings arrive HTML-escaped
  const T = dec(Object.assign({}, CFG.t));
  const reduced = matchMedia('(prefers-reduced-motion: reduce)').matches;
  const pub = (n, d) => { try { if (DV.track) DV.track.publish(n, d); else Shopify.analytics.publish(n, d); } catch (e) {} };
  const fmt = (c) => (DV.cart && DV.cart.fmt ? DV.cart.fmt(c) : (c / 100).toFixed(2));
  const ss = { get: (k) => { try { return sessionStorage.getItem(k); } catch (e) { return null; } }, set: (k, v) => { try { sessionStorage.setItem(k, v); } catch (e) {} } };
  const fill = (s, x, p) => String(s || '').replace(/\bX\b/g, () => x).replace(/\bP\b/g, () => p);  // functions: prices contain '$'
  const $$ = (sel, el) => Array.prototype.slice.call((el || D).querySelectorAll(sel));

  /* 1–2. catalog JSON (?view=dvjson): cached 30 min per language/currency/theme version, one request in flight per key */
  const inflight = {};
  // first page: taken over from an early fetch the page started itself (DV_PRE, e.g. the search page for a N° query)
  const page = (u) => {
    const pre = window.DV_PRE && DV_PRE[u]; if (pre) { delete DV_PRE[u]; return pre; }
    return fetch(u, { credentials: 'same-origin' }).then((r) => { if (r.status !== 200) throw new Error('dvjson ' + r.status); return r.json(); });
  };
  function get(h) {
    if (!h) return Promise.reject(new Error('dvjson: no handle'));
    const k = ['dvj', CFG.locale, CFG.currency, h, CFG.v].join('|');
    try { const c = JSON.parse(ss.get(k) || 'null'); if (c && Date.now() - c.t < 18e5) return Promise.resolve(c.d); } catch (e) {}
    if (inflight[k]) return inflight[k];
    const job = (async () => {
      let u = root + 'collections/' + encodeURIComponent(h) + '?view=dvjson', out = null;
      for (let i = 0; i < 4 && u; i++) {
        const d = await page(u);
        out = out || { h: d.h, n: d.n, items: [] }; out.items = out.items.concat(d.items || []); u = null;
        if (d.next) { const x = new URL(d.next, location.origin); x.searchParams.set('view', 'dvjson'); u = x.pathname + x.search; }
      }
      ss.set(k, JSON.stringify({ t: Date.now(), d: out }));
      return out;
    })();
    inflight[k] = job; job.then(() => delete inflight[k], () => delete inflight[k]);
    return job;
  }
  function norm(q) {
    const m = /^\s*#?\s*(ag|hg)?\s*[-\s]?\s*0*(\d{1,3})\s*$/i.exec(q == null ? '' : String(q));
    return m ? { prefix: m[1] ? m[1].toUpperCase() : null, num: ('00' + m[2]).slice(-3) } : null;
  }
  function byCode(q) {
    const n = norm(q); if (!n) return Promise.resolve([]);
    const want = n.prefix ? [n.prefix + '-' + n.num] : ['AG-' + n.num, 'HG-' + n.num];
    return get(CFG.allHandle).then((d) => d.items.filter((it) => want.indexOf(it.c) > -1));
  }
  DV.cat = { get, norm, byCode };

  /* 4. pocket state: bars, header badge and quick-add buttons follow the real cart (dv:cart from dv-cart.js) */
  let lastCart = null, lastN = -1;
  const bars = () => $$('[data-dv-pocketbar]');
  const strOf = (b) => b._s || (b._s = (() => { try { return dec(JSON.parse(b.querySelector('[data-dv-pb-str]').textContent)); } catch (e) { return {}; } })());
  function paint(cart) {
    const books = (cart.items || []).filter((i) => i.product_type === bookType);
    const n = books.reduce((s, i) => s + i.quantity, 0), thumbs = [];
    books.forEach((b) => { for (let k = 0; k < b.quantity && thumbs.length < 4 && b.image; k++) thumbs.push(b.image + (b.image.indexOf('?') > -1 ? '&' : '?') + 'width=120'); });
    const unit = books.length ? books[0].original_price : 0;
    // Shopify rounds each line's % discount down, so this matches the cart: $29.95 / $28.30 / $26.23
    const each = (k) => unit - Math.floor(unit * (tierOff[Math.min(k, 4)] || 0) + 1e-6);
    const drop = lastN > -1 && lastN < 4 && n >= 4;
    let shown = false;
    bars().forEach((bar) => {
      const S = strOf(bar);
      const txt = !n ? S.hint || S.empty : n < 4 ? fill(S.n, n, fmt(each(n + 1))) : n === 4 ? fill(S.full, 4, fmt(cart.total_price)) : fill(S.over, n - 4, '');
      const t = bar.querySelector('[data-dv-pb-txt]'), s = bar.querySelector('[data-dv-pb-sub]'), mini = bar.querySelector('[data-dv-pb-mini]');
      if (t) t.textContent = txt;
      if (s) s.textContent = n ? '' : S.empty_sub || '';
      if (mini) mini.innerHTML = [0, 1, 2, 3].map((i) => (thumbs[i] ? `<span><img src="${thumbs[i].replace(/"/g, '&quot;')}" alt="" width="60" height="80"></span>` : '<span class="e"></span>')).join('');
      bar.classList.toggle('is-full', n >= 4);
      if (drop) bar.classList.add('is-drop'); else if (n < 4) bar.classList.remove('is-drop');
      if (bar.dataset.mode === 'auto') bar.hidden = !n;
      if (!bar.hidden) shown = true;
    });
    D.body.classList.toggle('dv-has-pb', shown);
    $$('[data-dv-pocket-badge]').forEach((b) => {
      b.setAttribute('data-n', Math.min(n, 4)); b.classList.toggle('is-full', n >= 4);
      const a = b.closest('a, button'); if (a && T.badge) a.setAttribute('aria-label', fill(T.badge, Math.min(n, 4), ''));
    });
    lastCart = cart; lastN = n; markQuick();
  }
  function markQuick(scope) {
    if (!lastCart) return;
    const inCart = new Set((lastCart.items || []).map((i) => String(i.variant_id)));
    $$('[data-dv-quick]', scope).forEach((b) => {
      const on = inCart.has(b.getAttribute('data-dv-quick'));
      if (on === b.classList.contains('is-added')) return;
      if (!b._t) b._t = b.textContent;
      b.classList.toggle('is-added', on); b.textContent = on ? T.added || b._t : b._t;
    });
  }
  on('dv:cart', (e) => paint(e.detail || {}));
  DV.pocket = { paint, n: () => Math.max(lastN, 0) };

  /* 3. quick add: the cover flies into the next empty pocket; the 4th book drops the gold seal, then the drawer opens */
  function fly(card, idx) {
    const bar = bars().find((b) => { const r = box(b); return !b.hidden && r.height > 0 && r.bottom > 0 && r.top < innerHeight; });
    const img = card && card.querySelector('.dv-card__sleeve img, .dv-sleeve img'), to = bar && bar.querySelectorAll('[data-dv-pb-mini] > span')[Math.min(idx, 3)];
    if (reduced || !img || !to) return;
    const a = box(img), z = box(to); if (!a.width || !z.width) return;
    const g = new Image(); g.src = img.currentSrc || img.src; g.alt = ''; g.className = 'dv-ghost';
    g.style.cssText = `left:${a.left}px;top:${a.top}px;width:${a.width}px;height:${a.height}px`;
    D.body.appendChild(g);
    const done = () => g.remove(); if (!g.animate) return done();
    const dx = z.left + z.width / 2 - a.left - a.width / 2, dy = z.top + z.height / 2 - a.top - a.height / 2, k = Math.max(z.width / a.width, z.height / a.height);
    g.animate([{ transform: 'none', opacity: 1 }, { transform: `translate(${dx}px,${dy}px) scale(${k})`, opacity: 0.85 }], { duration: 350, easing: 'cubic-bezier(.2,.7,.3,1)', fill: 'forwards' }).onfinish = done;
    setTimeout(done, 1200);
  }
  on('click', (e) => {
    const b = e.target.closest('[data-dv-quick]');
    if (!b || b.closest('form') || !DV.cart) return;
    e.preventDefault(); if (b._busy) return;
    if (b.classList.contains('is-added')) { DV.cart.open(); return; }  // '✓ In your page' shows the page (drawer) instead of silently adding a 2nd copy
    // busy, not disabled: a disabled button drops keyboard focus to <body>, and the drawer would hand it back there
    b._busy = true; b.setAttribute('aria-disabled', 'true');
    if (!bars().some((x) => !x.hidden)) b.setAttribute('aria-live', 'polite');  // no pocket bar on screen (product rails): the label change is the feedback
    const card = b.closest('[data-dv-card]'), d = card ? card.dataset : {}, n0 = Math.max(lastN, 0);
    fly(card, n0);
    DV.cart.add([{ id: parseInt(b.getAttribute('data-dv-quick'), 10), quantity: 1 }], { open: false }).then(() => {
      pub('dv_quick_add', { handle: d.handle || '', series: d.series || '', ctx: d.ctx || '' });
      if (n0 < 4 && lastN >= 4) { pub('dv_pocket_full', { n: lastN, landing: D.body.dataset.dvTpl || '' }); setTimeout(() => DV.cart.open(), 700); }
    }).catch((err) => alert(err.message)).finally(() => { b._busy = false; b.removeAttribute('aria-disabled'); });
  });

  /* 6. card video: one shared muted <video> moved into whichever card should move; never more than one at a time */
  const conn = navigator.connection || {}, desk = matchMedia('(hover: hover) and (pointer: fine)').matches, seen = new Set();
  let vmode = CFG.video || 'stop', vid = null, cur = null, last = null, hoverT = 0, hoverC = null;
  if (vmode === 'stop' && ss.get('dvVid') === 'tap') vmode = 'tap';
  if (reduced || conn.saveData || /2g/.test(conn.effectiveType || '')) vmode = 'off';
  function video() {
    if (vid) return vid;
    vid = D.createElement('video');
    vid.muted = vid.playsInline = true; vid.preload = 'auto'; vid.className = 'dv-card__vid';
    ['muted', 'playsinline'].forEach((a) => vid.setAttribute(a, '')); vid.setAttribute('aria-hidden', 'true');
    vid.addEventListener('playing', () => {
      vid.classList.add('is-on');
      if (cur && !seen.has(cur)) { seen.add(cur); pub('dv_card_shake_play', { handle: cur.dataset.handle || '', mode: desk && vmode === 'stop' ? 'hover' : vmode }); }
    });
    vid.addEventListener('ended', () => { if (!vid.loop) stop(); });
    // the 480p twin is missing → fall back to the 1080p clip once
    vid.addEventListener('error', () => { const hd = cur && cur.dataset.videoHd; if (hd && vid.getAttribute('src') !== hd) { vid.src = hd; vid.play().catch(() => {}); } else stop(); });
    return vid;
  }
  function stop() {
    clearTimeout(hoverT);
    if (!vid || !cur) return;
    cur.classList.remove('is-playing'); cur = null;
    vid.pause(); vid.classList.remove('is-on');
    setTimeout(() => { if (!cur) vid.remove(); }, 320);  // fade back to the cover, then detach
  }
  function play(card, loop) {
    const sleeve = card && card.dataset.video && card.querySelector('.dv-card__sleeve');
    if (vmode === 'off' || !sleeve || D.body.classList.contains('dv-how-on')) return;
    if (cur && cur !== card) stop();
    const v = video();
    cur = last = card; card.classList.add('is-playing');
    v.classList.remove('is-on'); v.loop = !!loop;
    if (v.getAttribute('src') !== card.dataset.video) { v.poster = card.dataset.poster || ''; v.src = card.dataset.video; } else v.currentTime = 0;
    sleeve.appendChild(v);
    const p = v.play();
    // blocked autoplay (in-app browsers, iOS low power): 'tap' for the rest of the session
    if (p && p.catch) p.catch((err) => { if (err && err.name === 'AbortError') return; if (cur === card) stop(); if (!desk && vmode === 'stop') { vmode = 'tap'; ss.set('dvVid', 'tap'); chips(D); } });
  }
  function chips(scope) { if (vmode === 'tap') $$('[data-dv-shake-btn]', scope).forEach((b) => { b.hidden = false; }); }
  const vis = (el) => {
    const r = box(el), H = innerHeight; if (!r.height || !r.width) return { v: 0 };
    const vy = Math.max(0, Math.min(r.bottom, H) - Math.max(r.top, 0)) / r.height, vx = Math.max(0, Math.min(r.right, innerWidth) - Math.max(r.left, 0)) / r.width;
    return { v: vy * vx, d: Math.abs(r.top + r.height / 2 - H / 2) };
  };
  function pick() {  // phone: the clip ≥60% on screen closest to the middle, not the one played last
    if (vmode !== 'stop' || desk || D.hidden) return;
    if (cur) { if (vis(cur.querySelector('.dv-card__sleeve')).v >= 0.6) return; stop(); }
    let best = null, bd = 1e9;
    $$('[data-dv-card][data-video]').forEach((c) => { if (c === last) return; const o = vis(c.querySelector('.dv-card__sleeve') || c); if (o.v >= 0.6 && o.d < bd) { bd = o.d; best = c; } });
    if (best) play(best, false);
  }
  if (vmode !== 'off') {
    chips(D);
    if (desk && vmode === 'stop') {
      on('mouseover', (e) => {
        const c = e.target.closest('[data-dv-card][data-video]'); if (!c || c === hoverC) return;
        hoverC = c; clearTimeout(hoverT); hoverT = setTimeout(() => { if (hoverC === c) play(c, true); }, 150);
      });
      on('mouseout', (e) => {
        const c = e.target.closest('[data-dv-card][data-video]'); if (!c || c !== hoverC || (e.relatedTarget && c.contains(e.relatedTarget))) return;
        hoverC = null; clearTimeout(hoverT); if (cur === c) stop();
      });
    } else if (vmode === 'stop') {
      // armed only after a real scroll (>40px after touch/wheel/key), so nothing moves on the first screen
      let user = false, armed = false, st = 0; const y0 = scrollY, end = 'onscrollend' in window;
      ['touchstart', 'wheel', 'keydown', 'pointerdown'].forEach((t) => addEventListener(t, () => { user = true; }, { passive: true, once: true }));
      const later = () => { clearTimeout(st); st = setTimeout(pick, 500); };
      addEventListener('scroll', () => { if (!armed) armed = user && Math.abs(scrollY - y0) > 40; if (armed && !end) later(); }, { passive: true });
      if (end) addEventListener('scrollend', () => { if (armed) pick(); });
      on('scroll', (e) => { if (armed && e.target.matches && e.target.matches('[data-dv-rail]')) later(); }, { passive: true, capture: true });
    }
    on('click', (e) => {
      const b = e.target.closest('[data-dv-shake-btn]'); if (!b) return;
      e.preventDefault(); e.stopPropagation(); play(b.closest('[data-dv-card]'), false);
    });
    on('visibilitychange', () => { if (D.hidden) stop(); });
  }

  /* 5. load more: the next page of the same section appended in place (keeps view, sort_by, filter.*, q, utm_*); address bar unchanged */
  let loading = false;
  on('click', (e) => {
    const b = e.target.closest('[data-dv-loadmore]'); if (!b) return;
    e.preventDefault(); if (loading) return;
    const wrap = b.closest('[data-dv-loadmore-wrap]'), next = wrap && wrap.querySelector('a[rel="next"]'), sel = b.getAttribute('data-grid');
    const grid = sel && D.querySelector(sel);
    // fallback: plain next page built from the current address, so utm_* / click ids / view / sort_by survive (paginate.next.url drops utm)
    const away = () => { const x = new URL(location.href); x.hash = ''; x.searchParams.delete('section_id'); x.searchParams.set('page', (parseInt(b.dataset.page, 10) || 1) + 1); if (next || b.dataset.section) location.href = x.toString(); };
    if (!grid || !b.dataset.section) return away();
    loading = true; b.disabled = true; b.classList.add('is-loading'); b.setAttribute('aria-busy', 'true');
    const kb = D.activeElement === b, u = new URL(location.href); u.hash = '';
    u.searchParams.set('page', (parseInt(b.dataset.page, 10) || 1) + 1); u.searchParams.set('section_id', b.dataset.section);
    fetch(u.toString(), { credentials: 'same-origin' }).then((r) => { if (!r.ok) throw new Error(r.status); return r.text(); }).then((html) => {
      const doc = new DOMParser().parseFromString(html, 'text/html'), src = doc.querySelector(sel) || doc.querySelector('[data-dv-grid]');
      const added = (src ? $$(':scope > [data-dv-card]', src) : []).map((c) => grid.appendChild(D.importNode(c, true)));
      if (!added.length) { if (wrap) wrap.remove(); return; }  // the last page was already shown: just retire the button
      const nw = doc.querySelector('[data-dv-loadmore-wrap]');
      if (wrap) { if (nw) wrap.replaceWith(D.importNode(nw, true)); else wrap.remove(); }
      added.forEach((c) => { markQuick(c); chips(c); });
      if (kb) { const a = added[0].querySelector('a'); if (a) a.focus(); }
    }).catch(away).finally(() => { loading = false; if (b.isConnected) { b.disabled = false; b.classList.remove('is-loading'); b.removeAttribute('aria-busy'); } });
  });

  /* 7. rails: arrows scroll by 90% of the visible width and hide at either end */
  const near = (el, sel) => { for (let box = el.parentElement, i = 0; box && i < 4; box = box.parentElement, i++) { const f = box.querySelector(sel); if (f) return f; } return null; };
  function rail(scope) {
    $$('[data-dv-rail]', scope).forEach((r) => {
      if (r._dv) return; r._dv = 1;
      const prev = near(r, '[data-dv-rail-prev]'), next = near(r, '[data-dv-rail-next]');
      const upd = () => { if (prev) prev.hidden = r.scrollLeft <= 8; if (next) next.hidden = r.scrollLeft >= r.scrollWidth - r.clientWidth - 8; };  // 8px: snap padding
      r.addEventListener('scroll', upd, { passive: true }); addEventListener('resize', upd); upd();
    });
  }
  on('click', (e) => {
    const b = e.target.closest('[data-dv-rail-prev], [data-dv-rail-next]'), r = b && near(b, '[data-dv-rail]'); if (!r) return;
    r.scrollBy({ left: (b.hasAttribute('data-dv-rail-prev') ? -0.9 : 0.9) * r.clientWidth, behavior: reduced ? 'auto' : 'smooth' });
  });
  DV.rail = { init: rail };

  /* 8. series tape: centre the current tab inside its own scroller (never scrolls the page); then sync the cart once */
  function init() {
    rail(D);
    $$('.dv-chips--tape [aria-current="page"]').forEach((t) => {
      const s = t.parentElement; if (s.scrollWidth <= s.clientWidth) return;
      const a = box(t), b = box(s); s.scrollLeft += a.left + a.width / 2 - b.left - b.width / 2;
    });
    // one /cart.js read only when something on screen needs live numbers: a visible pocket bar, or a badge that already counts books
    const need = $$('[data-dv-pocketbar]').some((x) => !x.hidden) || $$('[data-dv-pocket-badge]').some((x) => +(x.getAttribute('data-n') || 0) > 0);
    if (DV.cart && need) DV.cart.refresh().catch(() => {});
  }
  if (D.readyState === 'loading') on('DOMContentLoaded', init); else init();
})();
